import { useMemo } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { AppBar, Toolbar, IconButton, useMediaQuery } from '@mui/material';
import MenuIcon from "../../../assets/images/icons/menu/menuIcon";
import { Permissions } from "../../../helpers/constants";
import useMenuAction from "../../../hooks/menu/useMenuAction";
import useMenuData from "../../../hooks/menu/useMenuData";
import { useHasPermission } from "../../../modules/permission/hooks/useHasPermission";
import { DRAWER_WIDTH } from "../../../themes/config";

// project import
import AppBarStyled from './appBarStyled';
import HeaderContent from "./headerContent/headerContent";

// assets

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

const Header = () => {
	const { drawerOpen } = useMenuData()
	const { setDrawerOpen } = useMenuAction()
	const theme = useTheme();
	const downLG = useMediaQuery(theme.breakpoints.down('lg'));
	const downSM = useMediaQuery(theme.breakpoints.down('sm'));
	const isOrganizer = useHasPermission([Permissions.BeOrganizer], { shouldView: true })
	// header content
	const headerContent = useMemo(() => <HeaderContent/>, []);

	const mainHeader = (
		<Toolbar
			sx={{
				width: '100%',
				pt: 'auto',
				backgroundColor: theme.palette.white.main
			}}
		>
			{downSM && (
				<IconButton
					aria-label="open drawer"
					onClick={() => setDrawerOpen(!drawerOpen)}
					edge="start"
					color="highlight"
					variant="contained"
					sx={{
						p: '16px',
						borderRadius: '16px',
						bgcolor: theme.palette.highlight.main,
						'&:hover': {
							background: theme.palette.highlight.main
						}
					}}
				>
					<MenuIcon/>
				</IconButton>
			)}
			{headerContent}
		</Toolbar>
	)
	
	// app-bar params
	const appBar = {
		position: 'absolute',
		color: 'inherit',
		elevation: 0,
		sx: {
			top: downSM  && !isOrganizer ? '50px' : 0,
			zIndex: 10,
			width: downSM ? '100%' : drawerOpen ? `calc(100% - ${DRAWER_WIDTH})` : 'calc(100% - 60px)',
			backgroundColor: theme.palette.primary.main,
			paddingRight: '0 !important'
		}
	};
	
	return (
		<>
			{!downLG ? (
				<AppBarStyled open={drawerOpen} {...appBar}>
					{mainHeader}
				</AppBarStyled>
			) : (
				<AppBar {...appBar}>{mainHeader}</AppBar>
			)}
		</>
	);
};

export default Header;
